import { RegionShared } from "@1games-ru/region-shared";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { setControlSettings } from "@/domains/settings/control/slice";

export default function useControlSettings() {
  const dispatch = useAppDispatch();

  const getControlSettings = useCallback(async () => {
    const response = await RpcMpProvider.callClient<
      typeof RegionShared.Client.Requests.GetBindsRequest,
      typeof RegionShared.Client.Responses.GetBindsResponse
    >(RegionShared.Client.Events.Account.GetBinds, {});

    if (response instanceof RpcMpProviderSuccessResponse) {
      dispatch(setControlSettings(response.data));
    }
  }, []);

  return {
    getControlSettings,
  };
}
